import { Component, OnInit } from '@angular/core';
import { Tracking} from '../../../_models/tracking';
import * as fromTracking from '../../../tracking/state/tracking.reducer';
import * as trackingActions from '../../../tracking/state/tracking.actions';
import { Store, select } from '@ngrx/store';
// import { takeWhile } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
  templateUrl: './tracking-shell.component.html'
})

export class TrackingShellComponent implements OnInit {

    // componentActive = true;
    // errorMessage$: Observable<string>;
    trackings$: Observable<Tracking[]>;
    currentTracking$: Observable<Tracking>;
    filterFields$: Observable<any>;

  constructor(
    private store: Store<fromTracking.State>
  ) {}

  ngOnInit() {

    // this.store.pipe(select(fromTracking.getTrackingList),
    //   takeWhile(() => this.componentActive))
    //   .subscribe(
    //   trackings => {
    //         console.log(' >>>> Suscribirse a store getTrackingList: ');
    //         console.log(trackings);

    //         this.trackings = trackings;
    //       }
    // );

    this.trackings$ = this.store.pipe(select(fromTracking.getTrackingList)) as Observable<Tracking[]>;
    this.currentTracking$ = this.store.pipe(select(fromTracking.getCurrentTracking)) as Observable<Tracking>;
    this.filterFields$ = this.store.pipe(select(fromTracking.getFilterFields)) as Observable<any>;
  }

  searchTrackings(searchParams): void {

    console.log('---> GetTrackingList searchParam ');
    console.log(searchParams);

    this.store.dispatch( new trackingActions.LoadTrackings(searchParams));
    // Se guarda el valor de los filtros de búsqueda de las obras.
    this.store.dispatch( new trackingActions.SetFilterFields(searchParams));

  } // End function searchTrackings

  setCurrentTracking(trackingIn: Tracking | null): void {

    console.log('---> setCurrentTracking trackingIn ');
    console.log(trackingIn);

    // if (trackingIn === null) {
    //   this.store.dispatch( new trackingActions.InicializeTracking());
    // }
    this.store.dispatch( new trackingActions.SetCurrentTracking(trackingIn));
    // this.store.dispatch( new trackingActions.LoadCurrencies());

  } // End function setCurrentTracking

  deleteTracking(deleteTracking: Tracking): void {

    console.log('---> deleteTracking: ');
    console.log(this.deleteTracking);

    this.store.dispatch( new trackingActions.DeleteTracking(deleteTracking));

  } // End function deleteTracking

} // End class TrackingShellComponent
